import React from 'react';
import Drawer from '@mui/material/Drawer';
import { AppBar, Container, IconButton, Toolbar, Typography } from '@mui/material';
import { CircleX } from 'lucide-react';

export default function CustomDrawer({ openDrawer, closeDrawer, drawerContent, variant, anchor, drawerTittle, customSx }) {

    return (
        <Drawer open={openDrawer} onClose={closeDrawer} variant={variant} anchor={anchor}  sx={{ ...customSx }}>
            <AppBar sx={{ position: 'relative', backgroundColor: '#172028 !important' }}>
                <Toolbar>
                    <Typography sx={{ mr: 3, flex: 1 }} variant="p" component="div">
                        {drawerTittle}
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={closeDrawer}
                        aria-label="close"
                    >
                        <CircleX />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Container>
                {drawerContent}
            </Container>
        </Drawer>
    );
}
